import * as React from "react";
import turkish from "./translations/turkish";

/**
 * Return text value of field name given with respect to given language
 * @param {string} fieldName
 * @returns {string}
 */

export function Language(fieldName: string) {

    let data:string;

    data = turkish[fieldName];

    return data;
}
